// In the event you wanted to style the autosuggest component completely in javascript 
// you can do so here. In fact all the code here commented and uncommmented 
// will let you do that. The only problem is that when you
// use window.innerWidth as the condition to simulate a media query, the media query 
// does not automatically kick in when you resize the window.  It seems that
// the media query css rules only get applied when page is re-rendered, so when 
// I resized window to mobile, the autosuggest styles would remain same until I refresh.
// Hence I commented out all the code and left the styles in the scss file, with 
// the exception of styles for the suggestion dropdown, which was giving 
// me problems when resizing app for mobile. 
// The reason it gave me a problem, is because I used the same scss file for 
// both  the email and name autosuggest components. When app is resized to mobile
// the suggestion drop down for the name field was not positioned properly. To separate  
// out the styling for this, i used JSS to pass in the theme prop to the autosuggest component
// that overrides the name styles I had in my scss file.

const nameMobileStyle = {
  // input:  {
  //     height: 22,
  //     // padding: '10 20',
  //     paddingLeft: 3,
  //     fontFamily: 'inherit',
  //     fontWeight: 300,
  //     fontSize: 10,
  //     border: '1px solid $greyshade2',
  //     borderRadius: 4,
  //     marginLeft: 0,
  //     // marginRight: '6rem',
  //     width: '13rem'
  //   },
  //   inputFocused: {
  //     outline: 'none'
  //   },
    suggestionsContainerOpen: {
      display: 'block',
      position: 'absolute',
      top: 44,
      width: 200,
      border: '1px solid lightgrey',
      backgroundColor: '#fff',
      fontFamily: 'inherit',
      fontWeight: 300,
      fontSize: 12,
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
      marginLeft: '.2rem',
      marginTop: -16,
      zIndex: 2
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none',
      textAlign: 'left',
      marginLeft: 36
    },
    suggestion: {
      fontSize: 10,
      height: 40,
      // padding: '7 0 7 0',
      paddingTop: 10,
      listStyleType: 'none',
      textAlign: 'left',
      borderBottom: '1px solid lightgrey' ,
      marginLeft: '-3.5rem'
    }
}


export const myAutosuggestStyle = function(inputField) {
  //  let desktopStyle = {};
   let mobileStyle  = nameMobileStyle;

  //  if (inputField === 'name') {
  //      desktopStyle = nameDesktopStyle;
  //      mobileStyle  = nameMobileStyle;
  //  } else 
  //  if (inputField === 'email') {
  //      desktopStyle = emailDesktopStyle;
  //      mobileStyle  = emailMobileStyle;
  //  }

   if (window.innerWidth < 480) {
     return mobileStyle;
   //  } else {
   //    return desktopStyle;
   //  }
   }
}
// const emailDesktopStyle = {
//   input:  {
//     height: 22,
//     padding: '10 20',
//     paddingLeft: '.5rem',
//     fontFamily: 'inherit',
//     fontWeight: 300,
//     fontSize: 12,
//     border: '1px solid $greyshade2',
//     borderRadius: 4,
//     paddingLeft:  8,
//     width: '28rem'
//   },
//   inputFocused: {
//     outline: 'none'
//   },
//   suggestionsContainerOpen: {
//     display: 'block',
//     position: 'absolute',
//     top: 44,
//     width: 276,
//     border: '1px solid lightgrey',
//     backgroundColor: '#fff',
//     fontFamily: 'inherit',
//     fontWeight: 300,
//     fontSize: 12,
//     borderBottomLeftRadius: 4,
//     borderBottomRightRadius: 4,
//     marginLeft: 1,
//     marginTop: -16,
//     zIndex: 2
//   },
//   suggestionsList: {
//     margin: 0,
//     padding: 0,
//     listStyleType: 'none',
//     textAlign: 'left'
//   },
//   suggestion: {
//     height: 40,
//     // padding: '10 5',
//     paddingTop: 10,
//     listStyleType: 'none',
//     textAlign: 'left',
//     borderBottom: '1px solid lightgrey' 
//   }
// }

// const emailMobileStyle = {

// input:  {
//     border: '1px solid $greyshade2',
//     borderRadius: 4,
//     height: 22,
//     fontFamily: 'inherit',
//     fontWeight: 300,
//     fontSize: 10,
//     marginLeft: '11.5rem',
//     width: '18rem',
//     // padding: '10 20'
//     paddingLeft: 3,
//   },
//   inputFocused: {
//     outline: 'none'
//   },
//   suggestionsContainerOpen: {
//     display: 'block',
//     position: 'absolute',
//     top: 44,
//     width: 200,
//     border: '1px solid lightgrey',
//     backgroundColor: '#fff',
//     fontFamily: 'inherit',
//     fontWeight: 300,
//     fontSize: 12,
//     borderBottomLeftRadius: 4,
//     borderBottomRightRadius: 4,
//     marginLeft: '9rem',
//     marginTop: -16,
//     zIndex: 2
//   },
//   suggestionsList: {
//     margin: 0,
//     padding: 0,
//     listStyleType: 'none',
//     textAlign: 'left',
//     marginLeft: 36
//   },
//   suggestion: {
//     fontSize: 10,
//     height: 40,
//     // padding: '7 0 7 0',
//     paddingTop: 10,
//     listStyleType: 'none',
//     textAlign: 'left',
//     borderBottom: '1px solid lightgrey' ,
//     marginLeft: '-2.5rem'
//   }
// }
// const nameDesktopStyle = {

//       input:  {
//         height: 22,
//         padding: '10 20',
//         fontFamily: 'inherit',
//         fontWeight: 300,
//         fontSize: 12,
//         border: '1px solid $greyshade2',
//         borderRadius: 4,
//         paddingLeft: 8,
//         width: '17rem'


//      },
//       inputFocused: {
//         outline: 'none'
//       },
//       suggestionsContainerOpen: {
//         display: 'block',
//         position: 'absolute',
//         top: 44,
//         width: 276,
//         border: '1px solid lightgrey',
//         backgroundColor: '#fff',
//         fontFamily: 'inherit',
//         fontWeight: 300,
//         fontSize: 12,
//         borderBottomLeftRadius: 4,
//         borderBottomRightRadius: 4,
//         marginLeft: 1,
//         marginTop: -16,
//         zIndex: 2
//       },
//       suggestionsList: {
//         margin: 0,
//         padding: 0,
//         listStyleType: 'none',
//         textAlign: 'left'
//       },
//       suggestion: {
//         height: 40,
//         // padding: '10 5',
//         paddingTop: 10,
//         listStyleType: 'none',
//         textAlign: 'left',
//         borderBottom: '1px solid lightgrey' 
//       }
// }




// WEBPACK FOOTER //
// ./src/components/PicContactsAutosuggestStyle.js